export type ExchangeTimezone = {
  id: string;
  label: string;
  location: string;
  timeZone: string;
};

// Major exchanges/timezones. Keep `timeZone` as an IANA time zone.
export const exchangeTimezones: ExchangeTimezone[] = [
  {
    id: 'ny-new-york',
    label: 'New York (NYSE/Nasdaq)',
    location: 'New York',
    timeZone: 'America/New_York',
  },
  {
    id: 'chicago-cme',
    label: 'Chicago (CME)',
    location: 'Chicago',
    timeZone: 'America/Chicago',
  },
  {
    id: 'minneapolis',
    label: 'Minneapolis',
    location: 'Minneapolis',
    timeZone: 'America/Chicago',
  },
  {
    id: 'toronto-tsx',
    label: 'Toronto (TSX)',
    location: 'Toronto',
    timeZone: 'America/Toronto',
  },
  {
    id: 'london-lse',
    label: 'London (LSE)',
    location: 'London',
    timeZone: 'Europe/London',
  },
  {
    id: 'frankfurt-xetra',
    label: 'Frankfurt (Xetra)',
    location: 'Frankfurt',
    timeZone: 'Europe/Berlin',
  },
  {
    id: 'paris-euronext',
    label: 'Paris (Euronext)',
    location: 'Paris',
    timeZone: 'Europe/Paris',
  },
  {
    id: 'zurich-six',
    label: 'Zurich (SIX)',
    location: 'Zurich',
    timeZone: 'Europe/Zurich',
  },
  {
    id: 'geneva',
    label: 'Geneva',
    location: 'Geneva',
    timeZone: 'Europe/Zurich',
  },
  {
    id: 'milan-borsa',
    label: 'Milan (Borsa Italiana)',
    location: 'Milan',
    timeZone: 'Europe/Rome',
  },
  {
    id: 'sao-paolo-b3',
    label: 'São Paulo (B3)',
    location: 'São Paulo',
    timeZone: 'America/Sao_Paulo',
  },
  {
    id: 'mumbai-nse',
    label: 'Mumbai (NSE/BSE)',
    location: 'Mumbai',
    timeZone: 'Asia/Kolkata',
  },
  {
    id: 'singapore-sgx',
    label: 'Singapore (SGX)',
    location: 'Singapore',
    timeZone: 'Asia/Singapore',
  },
  {
    id: 'hong-kong-hkex',
    label: 'Hong Kong (HKEX)',
    location: 'Hong Kong',
    timeZone: 'Asia/Hong_Kong',
  },
  {
    id: 'shanghai-sse',
    label: 'Shanghai (SSE)',
    location: 'Shanghai',
    timeZone: 'Asia/Shanghai',
  },
  {
    id: 'tokyo-tse',
    label: 'Tokyo (TSE)',
    location: 'Tokyo',
    timeZone: 'Asia/Tokyo',
  },
  {
    id: 'sydney-asx',
    label: 'Sydney (ASX)',
    location: 'Sydney',
    timeZone: 'Australia/Sydney',
  },
  {
    id: 'melbourne-asx',
    label: 'Melbourne (ASX)',
    location: 'Melbourne',
    timeZone: 'Australia/Melbourne',
  },
];
